import uniqBy from 'lodash/uniqBy';
import includes from 'lodash/includes';
import filter from 'lodash/filter';
import { updateState } from '../../Store';
import TextUtils from '../../../utils/TextUtils';
import AuthService from '../../../services/AuthService';

export function updateJobCategory(state, selectedCategory) {
  const { jobCategories } = state;
  if (jobCategories.includes(selectedCategory)) {
    const updatedJobs = jobCategories.filter(job => job !== selectedCategory);
    return updateState(state, { jobCategories: updatedJobs });
  }
  return updateState(state, { jobCategories: [...jobCategories, selectedCategory] });
}

export function updateUserDetails(state, userDetails) {
  const { name, phoneNumber, id } = userDetails;
  const userInfo = { userName: name, userMobile: phoneNumber, userId: id };
  AuthService.storeUserInfo(userInfo);
  return updateState(state, userInfo);
}

export function updateUserProfile(state, userProfile) {
  const { userInformation = {} } = userProfile;
  const { locale } = userInformation;
  const selectedLanguage = (state.preferredLanguages || []).find(item => item.value === locale);
  return updateState(state, {
    selectedLanguage,
    userProfile,
  });
}
export function updateLocalities(state, localites) {
  let locationsSelected = state.jobLocalities;
  // IF already there, remove it
  if (includes(locationsSelected, localites)) {
    locationsSelected = filter(locationsSelected, item => item !== localites);
    return updateState(state, { jobLocalities: uniqBy(locationsSelected) });
  }
  return updateState(state, { jobLocalities: uniqBy([...locationsSelected, localites]) });
}

export function updateUserExp(state, exp) {
  return updateState(state, { userWorkExp: exp });
}

export function updateSelectedSkills(state, selectedSkills) {
  const { userSkills } = state;
  if (userSkills.findIndex(it => it.value === selectedSkills.value) > -1) {
    const skills = userSkills.filter(job => job.value !== selectedSkills.value);
    return updateState(state, { userSkills: skills });
  }
  return updateState(state, { userSkills: [...userSkills, selectedSkills] });
}

export function updateJobPref(state, pref) {
  const {
    userJobPref: { prefs = [] },
  } = state;
  if (prefs.includes(pref)) {
    const skills = prefs.filter(job => job !== pref);
    return updateState(state, { userJobPref: { ...state.userJobPref, prefs: skills } });
  }
  return updateState(state, { userJobPref: { ...state.userJobPref, prefs: [...prefs, pref] } });
}
export function updateOTP(state, otp) {
  return updateState(state, {
    userOTP: otp,
    isValidOTP: TextUtils.isValidOTP(otp),
  });
}

export function updatePendingDocs(state, docDetails) {
  const { pendingDocs } = state;
  return updateState(state, {
    pendingDocs: { ...pendingDocs, [docDetails.type]: docDetails.doc },
  });
}

export function removePendingDocs(state, docDetails) {
  const { pendingDocs } = state;
  return updateState(state, {
    pendingDocs: { ...pendingDocs, [docDetails.type]: undefined },
  });
}

export function setJobCategories(state, jobCategories) {
  const jobCategoriesItems = [];
  Object.keys(jobCategories || {}).forEach(c => {
    jobCategoriesItems.push({ key: jobCategories[c], value: c });
  });
  return updateState(state, { jobCategoriesItems });
}

export default {};
